export function inputValidity(e) {
    if (e.target.value.trim() === "") {
        e.target.style.border = "2px solid red";
    } else {
        e.target.style.border = "none";
    }
}
